var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c(
        "b-form",
        { on: { submit: _vm.addOrUpdatePersonRecord } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "mb-4", attrs: { md: "9", sm: "12" } },
                [
                  this.person.id
                    ? _c("h4", { staticClass: "card-title mb-0" }, [
                        _vm._v(_vm._s(this.person.id))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !this.person.id
                    ? _c("h4", { staticClass: "card-title mb-0" }, [
                        _vm._v("Create New Person")
                      ])
                    : _vm._e()
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { sm: "12" } },
                [
                  _c("PersonForm", {
                    attrs: { person: _vm.person, chooseOrganization: true },
                    on: { updateVictimInfo: _vm.updateVictimInfo }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { attrs: { "align-h": "end" } },
                    [
                      _c(
                        "b-col",
                        { staticClass: "p-3", attrs: { cols: "auto" } },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "secondary",
                                href: "#/dashboard"
                              }
                            },
                            [_vm._v("Cancel")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: { click: _vm.addOrUpdatePersonRecord }
                            },
                            [_vm._v("Submit")]
                          ),
                          _vm._v(" "),
                          _vm.isAllowedToSharePerson
                            ? _c(
                                "b-button",
                                {
                                  attrs: { variant: "primary" },
                                  on: {
                                    click: _vm.addOrUpdatePersonRecordAndShare
                                  }
                                },
                                [_vm._v("Submit and Share")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.createdPerson.id && !_vm.shareAddon
                    ? _c(
                        "b-modal",
                        {
                          attrs: {
                            title: "Success",
                            visible: _vm.showCreatedModal,
                            "header-bg-variant": "success",
                            "header-text-variant": "light",
                            size: "sm",
                            centered: "",
                            id: "modal1",
                            "ok-only": ""
                          },
                          on: { ok: _vm.handleOk },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "modal-header-close",
                                fn: function() {
                                  return [_c("h4", [_vm._v("X")])]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            2419867756
                          )
                        },
                        [
                          _vm._v(" "),
                          _c("h4", [
                            _vm._v("Person Record Created Successfully")
                          ]),
                          _vm._v(" "),
                          _c("p", [_vm._v(_vm._s(_vm.createdPerson.id))])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.createdPerson.id && _vm.shareAddon
                    ? _c(
                        "b-modal",
                        {
                          attrs: {
                            title: "Success",
                            visible: _vm.showCreatedModal,
                            "header-bg-variant": "success",
                            "header-text-variant": "light",
                            size: "sm",
                            centered: "",
                            id: "modal1",
                            "ok-only": ""
                          },
                          on: { ok: _vm.handleShare },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "modal-header-close",
                                fn: function() {
                                  return [_c("h4", [_vm._v("X")])]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            2419867756
                          )
                        },
                        [
                          _vm._v(" "),
                          _c("h4", [
                            _vm._v("Person Record Created Successfully!")
                          ]),
                          _vm._v(" "),
                          _c("p", [_vm._v(_vm._s(_vm.createdPerson.id))]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("Click OK to set the Sharing Settings.")
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("CreateSharePersonModal", {
        attrs: {
          person: _vm.person,
          personId: _vm.personId,
          personFid: _vm.personFid,
          personOrganizationOwner: _vm.personOrganizationOwner,
          selectedGroup: _vm.selectedGroup
        },
        on: {
          createAndSharePerson: function($event) {
            return _vm.reroutePerson($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-84cd43c4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84cd43c4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/Admin/AddPerson.vue
// module id = 1717
// module chunks = 0